import { Component, h, Element, Prop, Event, EventEmitter, State, Listen} from '@stencil/core';
import i18nextInstance from '../../utils/i18n';


/**
 * AdPagination is a pagination component that can be used to navigate through pages.
 */
@Component({
  tag: 'ad-pagination',
  styleUrl: 'ad-pagination.css',
  shadow: true
})

export class AdPagination {

    @Element() el:HTMLElement;
    /** Current page. Default value: 1. */
    @Prop({reflect:true, mutable:true }) currentPage: number = 1;
    /** Total number of pages. Default value: 10. */
    @Prop({reflect:true}) totalPages: number = 10;
    /** Disables the pagination. Default value: false. */
    @Prop({reflect:true}) disabled: boolean;
    @State() maxPages: number = this.totalPages;
    @State() maxVisibleButtons: number = 6;
    @State() buttons: (string | number)[];
    @State() startPage: number = 1;
    /** Event is emitted when the current page changes. */
    @Event({bubbles: true, composed: true}) currentPageChanged: EventEmitter<number>;

    @State() isTranslated : boolean = false;
    
    @Listen('translationsLoaded', {target: 'window'})
    translationsLoadedHandler() {
        this.isTranslated = true;
    }

    onClickHander(e: Event) {
        const button = e.target as HTMLButtonElement
        if(button.innerText !== '...') {
            this.currentPage = parseInt(button.innerText);
            this.currentPageChanged.emit(this.currentPage);
        }
    }

    componentWillRender() {
        this.buttons = [];

        let startPage = 1;
		let endPage = this.totalPages;

		if (this.totalPages > this.maxVisibleButtons) {
			const halfMaxButtons = Math.floor(this.maxVisibleButtons / 2);
			if (this.currentPage > halfMaxButtons) {
			startPage = this.currentPage - halfMaxButtons;
			if (this.currentPage + halfMaxButtons > this.totalPages) {
				startPage = this.totalPages - this.maxVisibleButtons + 1;
			}
			endPage = Math.min(startPage + this.maxVisibleButtons - 1, this.totalPages);
		} else {
			endPage = this.maxVisibleButtons;
			}
		}

		if (startPage > 1) {
			this.buttons.push(1);
			this.buttons.push('...');
		}

		for (let i = startPage; i <= endPage; i++) {
			this.buttons.push(i);
		}

		if (endPage < this.totalPages) {
			this.buttons.push('...');
			this.buttons.push(this.totalPages);
		}
    }

    render() {
        return (
            <div class="pagination" aria-label={`${i18nextInstance.t('pagination')}`} role="navigation">
                {this.buttons.map(button => (
                    <button 
                        onClick={this.onClickHander.bind(this)}
                        disabled={button === "..." || this.disabled}
                        aria-hidden={button === "..." || this.disabled} 
                        aria-label={`${i18nextInstance.t('gotopage',{ pagenumber: button })}`}
                        class={button === this.currentPage ? 'active' : ''}
                    >
                        {button}
                    </button>
                ))}
            </div>
        )
    }
}